import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapParallax = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    const $itemsVerticalParallax1 = gsap.utils.toArray(".js-item-vertical-parallax-1");
    const $itemsVerticalParallax2 = gsap.utils.toArray(".js-item-vertical-parallax-2");
    const $itemsVerticalParallax3 = gsap.utils.toArray(".js-item-vertical-parallax-3");
    const $itemsVerticalParallax4 = gsap.utils.toArray(".js-item-vertical-parallax-4");

    function init() {

        ScrollTrigger.matchMedia({
            // desktop
            "(min-width: 1024px) and (prefers-reduced-motion: no-preference)": function() {
                if ($itemsVerticalParallax1) {
                    $itemsVerticalParallax1.forEach(item => {
                        gsap.to(item, {
                            yPercent: -25,
                            ease: "none",
                            scrollTrigger: {
                                trigger: item,
                                scrub: 1
                            },
                        });
                    });
                }

                if ($itemsVerticalParallax2) {
                    $itemsVerticalParallax2.forEach(item => {
                        gsap.to(item, {
                            yPercent: -40,
                            ease: "none",
                            scrollTrigger: {
                                trigger: item,
                                scrub: 1
                            },
                        });
                    });
                }

                if ($itemsVerticalParallax3) {
                    $itemsVerticalParallax3.forEach(item => {
                        gsap.to(item, {
                            yPercent: -65,
                            ease: "none",
                            scrollTrigger: {
                                trigger: item,
                                scrub: 1
                            },
                        });
                    });
                }

                // small parallax effect for cards
                if ($itemsVerticalParallax4) {
                    $itemsVerticalParallax4.forEach(item => {
                        gsap.to(item, {
                            yPercent: -15,
                            ease: "none",
                            scrollTrigger: {
                                trigger: item,
                                scrub: 1
                            },
                        });
                    });
                }
            },

            // mobile
            // "(max-width: 1023px) and (prefers-reduced-motion: no-preference)": function() {
            //     if ($itemsVerticalParallax1) {
            //         $itemsVerticalParallax1.forEach(item => {
            //             gsap.to(item, {
            //                 y: -25,
            //                 ease: "none",
            //                 scrollTrigger: {
            //                     trigger: item,
            //                     scrub: 1
            //                 },
            //             });
            //         });
            //     }
            //
            //     if ($itemsVerticalParallax2) {
            //         $itemsVerticalParallax2.forEach(item => {
            //             gsap.to(item, {
            //                 y: -40,
            //                 ease: "none",
            //                 scrollTrigger: {
            //                     trigger: item,
            //                     scrub: 1
            //                 },
            //             });
            //         });
            //     }
            //
            //     if ($itemsVerticalParallax3) {
            //         $itemsVerticalParallax3.forEach(item => {
            //             gsap.to(item, {
            //                 y: -65,
            //                 ease: "none",
            //                 scrollTrigger: {
            //                     trigger: item,
            //                     scrub: 1
            //                 },
            //             });
            //         });
            //     }
            //
            //     // small parallax effect for cards
            //     if ($itemsVerticalParallax4) {
            //         $itemsVerticalParallax4.forEach(item => {
            //             gsap.to(item, {
            //                 y: -15,
            //                 ease: "none",
            //                 scrollTrigger: {
            //                     trigger: item,
            //                     scrub: 1
            //                 },
            //             });
            //         });
            //     }
            // }
        })
    }

    return {
        init: init
    }

})(jQuery);